import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "@/api/DynamicBaseQuery";
import { APIEndpoints } from "@/constants/apiEndpoints";
import type {
  DIGITAL_ID_ROLLOUT_STATUS,
  DIGITAL_ID_TEMPLATE,
  TGetCompanyDigitalIdEmployeesResponse,
  TGetCompanyDigitalIdStatsResponse,
} from "@/types/digital-id.interface";

interface IGetCompanyDigitalIdEmployeesParams {
  page?: number;
  limit?: number;
  search?: string;
  status?: DIGITAL_ID_ROLLOUT_STATUS;
  templateKey?: DIGITAL_ID_TEMPLATE;
}

export const companyDigitalIdApi = createApi({
  reducerPath: "companyDigitalIdApi",
  baseQuery: dynamicBaseQuery,
  tagTypes: ["CompanyDigitalIdEmployees", "CompanyDigitalIdStats"],
  endpoints: (builder) => ({
    getCompanyDigitalIdStats: builder.query<
      TGetCompanyDigitalIdStatsResponse,
      void
    >({
      query: () => ({ url: APIEndpoints.DigitalId.CompanyStats }),
      providesTags: ["CompanyDigitalIdStats"],
    }),
    getCompanyDigitalIdEmployees: builder.query<
      TGetCompanyDigitalIdEmployeesResponse,
      IGetCompanyDigitalIdEmployeesParams
    >({
      query: (params) => ({
        url: APIEndpoints.DigitalId.CompanyEmployees,
        params,
      }),
      providesTags: ["CompanyDigitalIdEmployees"],
    }),
  }),
});

export const {
  useGetCompanyDigitalIdStatsQuery,
  useGetCompanyDigitalIdEmployeesQuery,
} = companyDigitalIdApi;
